import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export interface IUpdateAdminProfileSitesParams {
  luid: string;
  siteIds: string[];
}

export interface IUpdateAdminProfileSitesResult extends IResult {
}

/**
 * Updates the sites associated with an admin profile.
 */
export class UpdateAdminProfileSitesRequest extends Request<IUpdateAdminProfileSitesParams, IUpdateAdminProfileSitesResult> {
  constructor(params: IUpdateAdminProfileSitesParams) {
    super('updateAdminProfileSites', params);
  }
}
